export var NativeStreamColumnType;
(function (NativeStreamColumnType) {
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_UNSPECIFIED"] = "NATIVE_STREAM_COLUMN_TYPE_UNSPECIFIED";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_BOOLEAN"] = "BOOLEAN";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_INT"] = "INT";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_LONG"] = "LONG";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_FLOAT"] = "FLOAT";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_DOUBLE"] = "DOUBLE";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_STRING"] = "STRING";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_TIMESTAMP"] = "TIMESTAMP";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_DATE"] = "DATE";
    NativeStreamColumnType["NATIVE_STREAM_COLUMN_TYPE_VARIANT"] = "VARIANT";
})(NativeStreamColumnType || (NativeStreamColumnType = {}));
